// extracted by mini-css-extract-plugin
module.exports = {"img-text-card-box":"e_","imgTextCardBox":"e_","text-box":"fa","textBox":"fa","remark-val":"fb","remarkVal":"fb"};